'use strict';

const RestUtils = require('utils/RestUtils'),
    DashboardServiceCache = require('./DashboardServiceCache'),
    SessionStore = require('stores/SessionStore'),
    LocaleUtils = require('utils/LocaleUtils'),
    Security = require('./Security').auth,
    Constants = require('constants/AppConstants'),
    get = require('lodash/object').get,
    hostApi = process.env.URL_API;

const DashboardService = {

    getOrders(success, failure) {
        var ajax = RestUtils.createXHR();
        ajax.addEventListener('error', failure);
        ajax.addEventListener('load', function () {
            RestUtils.handlerResponse(this, success, failure);
        });
        ajax.open('GET', hostApi + '/orders/' + SessionStore.getCurrentApplicant());
        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
        ajax.send();
    },

    fetchNextDashboardContent(from, to, applicant, success, failure) {
        var ajax = RestUtils.createXHR();
        ajax.addEventListener('error', failure);
        ajax.addEventListener('load', function () {
            RestUtils.handlerResponseWithFullLogout(this, success, failure);
        });

        ajax.open('GET', hostApi + '/orders/' + applicant + '/range?from=' + from + '&to=' + to);
        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
        ajax.send();
    },

    addOrder(order, success, failure) {
        var ajax = RestUtils.createXHR();
        ajax.addEventListener('error', failure);
        ajax.addEventListener('load', function () {
            RestUtils.handlerResponse(this, success, failure);
        });
        ajax.open('POST', hostApi + '/orders/' + SessionStore.getCurrentApplicant(), true);
        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
        ajax.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
        ajax.send(JSON.stringify(order));
    },

    changeFreeToProVersion(success, failure) {
        var ajax = RestUtils.createXHR();
        ajax.addEventListener('error', failure);
        ajax.addEventListener('load', function () {
            RestUtils.handlerResponse(this, success, failure);
        });
        ajax.open('POST', hostApi + '/applicants/change-version/' + Constants.LICENSE_TRIAL_FULL_VERSION, true);
        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
        ajax.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
        ajax.send();
    },

    fetchDashboardContent(success, failure) {
        var ajax = RestUtils.createXHR();
        ajax.addEventListener('error', failure);
        ajax.addEventListener('load', function () {
            RestUtils.handlerResponse(this, success, failure);
        });
        ajax.open('GET', hostApi + '/orders/' + Security.getCurrentApplicant() + '/dashboard');
        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
        ajax.setRequestHeader(Constants.LOCALE_CUSTOM_HEADER, LocaleUtils.getCurrentLocale());
        ajax.setRequestHeader(Constants.COUNTRY_CODE_CUSTOM_HEADER, get(SessionStore.getCurrentCountry(), 'cca2'));
        ajax.setRequestHeader(Constants.CURRENCY_CODE_CUSTOM_HEADER, get(SessionStore.getCurrentCurrency(), 'code'));
        ajax.send();
    },

    fetchDashboardInventoryItemsContent(success, failure) {
        var ajax = RestUtils.createXHR();
        ajax.addEventListener('error', failure);
        ajax.addEventListener('load', function () {
            RestUtils.handlerResponse(this, success, failure);
        });
        ajax.open('GET', hostApi + '/orders/' + Security.getCurrentApplicant() + '/dashboard-items');
        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
        ajax.setRequestHeader(Constants.LOCALE_CUSTOM_HEADER, LocaleUtils.getCurrentLocale());
        ajax.setRequestHeader(Constants.COUNTRY_CODE_CUSTOM_HEADER, get(SessionStore.getCurrentCountry(), 'cca2'));
        ajax.setRequestHeader(Constants.CURRENCY_CODE_CUSTOM_HEADER, get(SessionStore.getCurrentCurrency(), 'code'));
        ajax.send();
    },


    fetchDashboardInventoryProductsContent(success, failure) {
        var ajax = RestUtils.createXHR();
        ajax.addEventListener('error', failure);
        ajax.addEventListener('load', function () {
            RestUtils.handlerResponse(this, success, failure);
        });
        ajax.open('GET', hostApi + '/orders/' + Security.getCurrentApplicant() + '/dashboard-products');
        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
        ajax.setRequestHeader(Constants.LOCALE_CUSTOM_HEADER, LocaleUtils.getCurrentLocale());
        ajax.setRequestHeader(Constants.COUNTRY_CODE_CUSTOM_HEADER, get(SessionStore.getCurrentCountry(), 'cca2'));
        ajax.setRequestHeader(Constants.CURRENCY_CODE_CUSTOM_HEADER, get(SessionStore.getCurrentCurrency(), 'code'));
        ajax.send();
    },


    fetchScheduleBoardByDate(date, success, failure) {
        var ajax = RestUtils.createXHR();
        ajax.addEventListener('error', failure);
        ajax.addEventListener('load', function () {
            RestUtils.handlerResponse(this, success, failure);
        });
        ajax.open('GET', `${hostApi}/tasks/date/${date}`);
        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
        ajax.send();
    },

    saveChangedUserTaskName({ date, name, id, originalName }, success, failure) {
        var ajax = RestUtils.createXHR();
        ajax.addEventListener('error', failure);
        ajax.addEventListener('load', function () {
            RestUtils.handlerResponse(this, success, failure);
        });
        ajax.open('POST', `${hostApi}/tasks`);
        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
        ajax.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
        ajax.send(JSON.stringify({
            applicantName: SessionStore.getCurrentApplicant(),
            date,
            name,
            id,
            oldTemplateName: originalName
        }));
    },

    addUserTaskName({ date, note, id, listId, listName, name, checked }, success, failure) {
        const ajax = RestUtils.createXHR();
        ajax.addEventListener('error', failure);
        ajax.addEventListener('load', function () {
            RestUtils.handlerResponse(this, success, failure);
        });
        ajax.open('POST', `${hostApi}/tasks/date/${date}/note`);
        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
        ajax.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
        ajax.send(JSON.stringify({
            applicantName: SessionStore.getCurrentApplicant(),
            message: note,
            id,
            taskListId: listId,
            taskListName: listName,
            name,
            checked
        }));
    },

    deleteUserTaskName({ id, listName }, success, failure) {
        var ajax = RestUtils.createXHR();
        ajax.addEventListener('error', failure);
        ajax.addEventListener('load', function () {
            RestUtils.handlerResponse(this, success, failure);
        });
        ajax.open('DELETE', `${hostApi}/tasks/${id}`);
        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
        ajax.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
        ajax.send(JSON.stringify({
            id,
            name: listName
        }));
    },

    removeUserTask(data, onSuccess, onFailure) {
        const ajax = RestUtils.createXHR();
        ajax.addEventListener('error', onFailure);
        ajax.addEventListener('load', function () {
            RestUtils.handlerResponse(this, onSuccess, onFailure);
        });
        ajax.open('DELETE', `${hostApi}/tasks/${data.listId}/task/${data.id}`);
        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
        ajax.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
        ajax.send();
    },

    publishDraft(success, failure) {
        var ajax = RestUtils.createXHR();
        ajax.addEventListener('error', failure);
        ajax.addEventListener('load', function () {
            RestUtils.handlerResponse(this, success, failure);
        });
        ajax.open('POST', hostApi + '/orders/' + SessionStore.getCurrentApplicant() + '/publish', true);
        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
        ajax.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
        ajax.send();
    },

    undoDraft(success, failure) {
        var ajax = RestUtils.createXHR();
        ajax.addEventListener('error', failure);
        ajax.addEventListener('load', function () {
            RestUtils.handlerResponse(this, success, failure);
        });
        ajax.open('DELETE', hostApi + '/orders/' + SessionStore.getCurrentApplicant() + '/undo', true);
        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
        ajax.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
        ajax.send();
    },

    redoDraft(success, failure) {
        var ajax = RestUtils.createXHR();
        ajax.addEventListener('error', failure);
        ajax.addEventListener('load', function () {
            RestUtils.handlerResponse(this, success, failure);
        });
        ajax.open('DELETE', hostApi + '/orders/' + SessionStore.getCurrentApplicant() + '/redo', true);
        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
        ajax.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
        ajax.send();
    },


    getDraft(success, failure) {
        var ajax = RestUtils.createXHR();
        ajax.addEventListener('error', failure);
        ajax.addEventListener('load', function () {
            RestUtils.handlerResponse(this, success, failure);
        });
        ajax.open('GET', hostApi + '/orders/' + SessionStore.getCurrentApplicant() + '/draft');
        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
        ajax.send();
    },

    saveDraft(success, failure) {
        var ajax = RestUtils.createXHR();
        ajax.addEventListener('error', failure);
        ajax.addEventListener('load', function () {
            RestUtils.handlerResponse(this, success, failure);
        });
        ajax.open('POST', hostApi + '/orders/' + SessionStore.getCurrentApplicant() + '/draft');
        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
        ajax.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
        ajax.send(JSON.stringify({
            'applicant': SessionStore.getCurrentApplicant(),
            'operations': DashboardServiceCache.getPendingOperations()
        }));
    },

    removeOrder(id, success, failure) {
        var ajax = RestUtils.createXHR();
        ajax.addEventListener('error', failure);
        ajax.addEventListener('load', function () {
            RestUtils.handlerResponse(this, success, failure);
        });
        ajax.open('DELETE', hostApi + '/orders/' + SessionStore.getCurrentApplicant() + '/' + id);
        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
        ajax.send();
    },

    changeOrder(order, success, failure) {
        var ajax = RestUtils.createXHR();
        ajax.addEventListener('error', failure);
        ajax.addEventListener('load', function () {
            RestUtils.handlerResponse(this, success, failure);
        });
        ajax.open('PUT', hostApi + '/orders/' + SessionStore.getCurrentApplicant(), true);
        ajax.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
        ajax.send(JSON.stringify(order));
    },

    deleteTank(id, success, failure) {
        var ajax = RestUtils.createXHR();
        ajax.addEventListener('error', failure);
        ajax.addEventListener('load', function () {
            RestUtils.handlerResponse(this, success, failure);
        });
        ajax.open('DELETE', hostApi + '/tanks/' + SessionStore.getCurrentApplicant() + '/' + id);
        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
        ajax.send();
    },

    getTanks(page, success, failure) {
        var ajax = RestUtils.createXHR();
        ajax.addEventListener('error', failure);
        ajax.addEventListener('load', function () {
            RestUtils.handlerResponse(this, success, failure);
        });
        ajax.open('GET', hostApi + '/tanks/' + SessionStore.getCurrentApplicant() + '?page=' + page + '&size=' + Constants.MAX_ITEMS_BY_PAGES_ADMINS);
        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
        ajax.send();
    },

    getAllTanks(success, failure) {
        var ajax = RestUtils.createXHR();
        ajax.addEventListener('error', failure);
        ajax.addEventListener('load', function () {
            RestUtils.handlerResponse(this, success, failure);
        });
        ajax.open('GET', hostApi + '/tanks/' + SessionStore.getCurrentApplicant());
        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
        ajax.send();
    },

    getTanksBy(filter, success, failure) {
        var ajax = RestUtils.createXHR();
        ajax.addEventListener('error', failure);
        ajax.addEventListener('load', function () {
            RestUtils.handlerResponse(this, success, failure);
        });
        ajax.open('GET', hostApi + '/tanks/' + SessionStore.getCurrentApplicant() + '/filter' + RestUtils.formatQueryString(filter));
        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
        ajax.send();
    },

    changeTank(tank, success, failure) {
        var ajax = RestUtils.createXHR();
        ajax.addEventListener('error', failure);
        ajax.addEventListener('load', function () {
            RestUtils.handlerResponse(this, success, failure);
        });
        ajax.open('PUT', hostApi + '/tanks/' + SessionStore.getCurrentApplicant(), true);
        ajax.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
        ajax.send(JSON.stringify(tank));
    },

    addTank(tank, success, failure) {
        var ajax = RestUtils.createXHR();
        ajax.addEventListener('error', failure);
        ajax.addEventListener('load', function () {
            RestUtils.handlerResponse(this, success, failure);
        });
        ajax.open('POST', hostApi + '/tanks/' + SessionStore.getCurrentApplicant(), true);
        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
        ajax.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
        ajax.send(JSON.stringify(tank));
    },

    addBeerStyleConfiguration(beerStyleConfiguration, success, failure) {
        var ajax = RestUtils.createXHR();
        ajax.addEventListener('error', failure);
        ajax.addEventListener('load', function () {
            RestUtils.handlerResponse(this, success, failure);
        });
        ajax.open('POST', hostApi + '/stylebeer/' + SessionStore.getCurrentApplicant() + '/configurations', true);
        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
        ajax.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
        ajax.send(JSON.stringify(beerStyleConfiguration));
    },

    changeBeerStyleConfiguration(beerStyleConfiguration, success, failure) {
        var ajax = RestUtils.createXHR();
        ajax.addEventListener('error', failure);
        ajax.addEventListener('load', function () {
            RestUtils.handlerResponse(this, success, failure);
        });
        ajax.open('PUT', hostApi + '/stylebeer/' + SessionStore.getCurrentApplicant() + '/configurations', true);
        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
        ajax.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
        ajax.send(JSON.stringify(beerStyleConfiguration));
    },

    deleteBeerStyleConfiguration(id, success, failure) {
        var ajax = RestUtils.createXHR();
        ajax.addEventListener('error', failure);
        ajax.addEventListener('load', function () {
            RestUtils.handlerResponse(this, success, failure.bind(this));
        });
        ajax.open('DELETE', hostApi + '/stylebeer/' + SessionStore.getCurrentApplicant() + '/configurations', true);
        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
        ajax.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
        ajax.send(id);
    },

    getBeerStyleConfiguration(beerStyleId, success, failure) {
        var ajax = RestUtils.createXHR();
        ajax.addEventListener('error', failure);
        ajax.addEventListener('load', function () {
            RestUtils.handlerResponse(this, success, failure);
        });
        ajax.open('GET', hostApi + '/stylebeer/' + SessionStore.getCurrentApplicant() + '/configurations/' + beerStyleId);
        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
        ajax.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
        ajax.send();
    },

    getStyleBeers(success, failure) {
        var ajax = RestUtils.createXHR();
        ajax.addEventListener('error', failure);
        ajax.addEventListener('load', function () {
            RestUtils.handlerResponse(this, success, failure);
        });
        ajax.open('GET', hostApi + '/stylebeer/' + SessionStore.getCurrentApplicant(), true);
        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
        ajax.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
        ajax.send();
    },

    getIcons(success, failure) {
        var ajax = RestUtils.createXHR();
        ajax.addEventListener('error', failure);
        ajax.addEventListener('load', function () {
            RestUtils.handlerResponse(this, success, failure);
        });
        ajax.open('GET', hostApi + '/icons', true);
        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
        ajax.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
        ajax.send();
    },

    changeStyleBeer(styleBeer, success, failure) {
        var ajax = RestUtils.createXHR();
        ajax.addEventListener('error', failure);
        ajax.addEventListener('load', function () {
            RestUtils.handlerResponse(this, success, failure);
        });
        ajax.open('PUT', hostApi + '/stylebeer/' + SessionStore.getCurrentApplicant(), true);
        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
        ajax.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
        ajax.send(JSON.stringify(styleBeer));
    },

    addStyleBeer(styleBeer, success, failure) {
        var ajax = RestUtils.createXHR();
        ajax.addEventListener('error', failure);
        ajax.addEventListener('load', function () {
            RestUtils.handlerResponse(this, success, failure);
        });
        ajax.open('POST', hostApi + '/stylebeer/' + SessionStore.getCurrentApplicant(), true);
        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
        ajax.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
        ajax.send(JSON.stringify(styleBeer));
    },

    deleteStyleBeer(styleBeer, success, failure) {
        var ajax = RestUtils.createXHR();
        ajax.addEventListener('error', failure);
        ajax.addEventListener('load', function () {
            RestUtils.handlerResponse(this, success, failure.bind(this));
        });
        ajax.open('DELETE', hostApi + '/stylebeer/' + SessionStore.getCurrentApplicant(), true);
        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
        ajax.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
        ajax.send(JSON.stringify({ id: styleBeer }));
    }
};
module.exports = DashboardService;



/** WEBPACK FOOTER **
 ** ./src/services/DashboardServiceImpl.js
 **/